export default __webpack_public_path__ + "static/media/post.3a1a562a.png";